'use client';

import { useEffect } from 'react';

export default function UserWayProvider({ lang }) {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const existingScript = document.getElementById('userway-script');

    if (existingScript) {
      // Update language attribute when it changes
      const newLang = lang === 'en' ? 'en-us' : 'ar';
      existingScript.setAttribute('data-language', newLang);

      // Reinitialize UserWay with new language if available
      if (window.UserWay) {
        window.UserWay.changeLanguage?.(newLang);
      }
      return;
    }

    const script = document.createElement('script');
    script.id = 'userway-script';
    script.src = 'https://cdn.userway.org/widget.js';
    script.async = true;
    script.setAttribute('data-account', 'ORMiK6wHZO');
    script.setAttribute('data-language', lang === 'en' ? 'en-us' : 'ar');

    document.body.appendChild(script);
  }, [lang]);

  return null;
}
